import React from 'react';

const AuthLayout = ({ 
  title, 
  subtitle, 
  children, 
  showBackgroundPattern = true 
}) => {
  return (
    <div className="min-h-screen bg-sky-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {showBackgroundPattern && (
        <div className="absolute inset-0 bg-sky-100">
          <div className="absolute inset-0 bg-gradient-to-br from-sky-50 to-sky-200 opacity-50"></div>
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
      )}
      
      <div className="relative max-w-md w-full space-y-8">
        <div className="bg-white rounded-xl shadow-lg p-8 border border-sky-200">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-gray-600">
                {subtitle}
              </p>
            )}
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
